
import { defineComponent, onMounted, ref, watch } from 'vue';

export default defineComponent({
  name: 'DhIoEmhRegionPickerPopup',
  props: {
    isVisible: {
      type: Boolean,
      required: true,
      default: false,
    },
    isRequired: {
      type: Boolean,
      required: true,
      default: false,
    },
    region: {
      type: String,
      required: true,
      default: '',
    },
    regexValidation: {
      type: String,
      required: false,
      default: '',
    },
    digitAmount: {
      type: Number,
      required: true,
    },
  },
  emits: ['close', 'region-selected'],
  setup(props, { emit }) {
    const success = ref(false);
    const error = ref(false);
    const selectedRegion = ref('');

    // set error/success states when selectedRegion is set externally
    const setSelectedRegion = (region: string) => {
      selectedRegion.value = region;
      const isValid = validRegion(selectedRegion.value);
      success.value = isValid;
      error.value = !isValid && region !== '';
    };

    onMounted(async () => {
      setSelectedRegion(props.region);
    });

    // reset selected region to stored region when flyout gets re-opened
    watch(
      () => props.isVisible,
      (isVisible) => {
        if (isVisible) {
          setSelectedRegion(props.region);
        }
      },
    );

    watch(() => props.region, setSelectedRegion);

    const resetAndClose = () => {
      selectedRegion.value = '';
      emit('region-selected', '');
      emit('close');
    };

    const resetValidationState = () => {
      error.value = false;
      success.value = false;
    };

    const close = () => {
      emit('close');
    };

    const validate = () => {
      if (!validRegion(selectedRegion.value)) {
        success.value = false;
        error.value = true;
      } else {
        emit('region-selected', selectedRegion.value);
        success.value = true;
        error.value = false;

        close();
      }
    };

    const validRegion = (value: string) => {
      // accept all inputs if no validation regex is provided
      if (!props.regexValidation) {
        return true;
      }
      let re = new RegExp(props.regexValidation!);
      return re.test(value);
    };

    return {
      success,
      error,
      resetAndClose,
      validate,
      selectedRegion,
      resetValidationState,
    };
  },
});
